"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BoxedButtonBase } from "./ButtonBase.js";
import { getButtonVariantProps } from "./createButtonVariant.js";
const PrimaryButton = forwardRef(function PrimaryButton2(props, ref) {
  return jsx(BoxedButtonBase, { ref, ...getButtonVariantProps("primary", props) });
});
export {
  PrimaryButton
};
